// Library
import React, { useState } from 'react'

//Ui
import Box from 'ui/Box'
import Row from 'ui/Row'
import Col from 'ui/Col'
import Text from 'ui/Text'
import Button from 'ui/Button'

// Components
import LessorChangePasswordView from 'components/Lessor/LessorChangePasswordView'
import LessorChangePasswordForm from 'components/Lessor/LessorChangePasswordForm'

const LessorChangePassword = () => {
  //State
  const [editMode, setEditMode] = useState(false)

  // Render
  return (
    <Row>
      <Col xs={12}>
        <Text bold={true} color="#000">
          Account password
        </Text>
        {editMode ? (
          <>
            <Button
              variant="outline-primary"
              width={130}
              onClick={() => setEditMode(false)}
            >
              Cancel
            </Button>
            <Button
              width={130}
              className="m-2"
              form="changePasswordForm"
              type="submit"
            >
              Save changes
            </Button>
          </>
        ) : (
          <Button
            className="mb-3"
            variant="link"
            underline
            onClick={() => setEditMode(true)}
          >
            Edit password
          </Button>
        )}
      </Col>

      <Col md={10} sm={{ span: 'auto' }}>
        <Box
          style={{
            border: '1px solid #EBEEF5',
            borderRadius: '4px',
          }}
        >
          {editMode ? (
            <LessorChangePasswordForm />
          ) : (
            <LessorChangePasswordView />
          )}
        </Box>
      </Col>
    </Row>
  )
}

export default LessorChangePassword
